/** Passport / guest QR queue tokens are not skin analysis session ids. */
export function isPassportQueueReference(value) {
  const s = String(value || '').trim();
  if (!s) return false;
  return /^passport-/i.test(s);
}

function readSnap(checkin) {
  return checkin?.customer_snapshot && typeof checkin.customer_snapshot === 'object'
    ? checkin.customer_snapshot
    : {};
}

export function snapshotReportSessions(checkin) {
  const snap = readSnap(checkin);
  const refToken = String(snap.reference_token || snap.referenceToken || '').trim();
  const pickSkin = (raw) => {
    const skin = String(raw || '').trim();
    if (!skin || skin.toUpperCase().startsWith('HA-')) return '';
    if (isPassportQueueReference(skin)) return '';
    if (refToken && skin === refToken && isPassportQueueReference(refToken)) return '';
    return skin;
  };
  const skinCandidates = [
    snap.salon_reference,
    snap.skin_reference,
    snap.analysis_reference,
    snap.session_reference,
  ];
  let skinSessionId = '';
  for (const raw of skinCandidates) {
    const picked = pickSkin(raw);
    if (picked) {
      skinSessionId = picked;
      break;
    }
  }
  const hair = String(snap.hair_insight_session_id || snap.hairInsightSessionId || '').trim();
  const hairSessionId = hair.startsWith('HA-') ? hair : '';
  return { skinSessionId, hairSessionId };
}

export function hasAnalysisProductsReady(checkin) {
  const snap = readSnap(checkin);
  if (Boolean(snap.recommended_products_ready)) return true;
  if (Boolean(snap.product_cart_pending)) return true;
  if (Array.isArray(snap.product_cart) && snap.product_cart.length > 0) return true;
  return false;
}

function visitAnalysisStamped(checkin) {
  const snap = readSnap(checkin);
  return Boolean(
    snap.recommended_products_ready ||
      snap.analysis_complete ||
      snap.recommended_products_ready_at ||
      snap.recommendedProductsReadyAt,
  );
}

/** Lobby may offer report / product preview only after this visit has analysis output. */
export function canLobbyAnalysisPreview(checkin) {
  if (hasAnalysisProductsReady(checkin)) return true;
  if (!visitAnalysisStamped(checkin)) return false;
  const { skinSessionId, hairSessionId } = snapshotReportSessions(checkin);
  return Boolean(skinSessionId || hairSessionId);
}

export function lobbyPreviewCtaLabel(checkin) {
  const { skinSessionId, hairSessionId } = snapshotReportSessions(checkin);
  if (skinSessionId && hairSessionId) return 'Skin & hair reports';
  if (skinSessionId) return 'Analysis report';
  if (hairSessionId) return 'Hair analysis report';
  return 'Analysis report';
}
